import { useMutation, useQuery } from '@apollo/client';
import { useAccount, useLogin } from '@bnnvara/accounts';
import { useEffect, useState } from 'react';

import { Like } from '../../api/mutations/like.gql';
import { GetUserLike } from '../../api/queries/me/likes.gql';

export function useUserLike({ id, likeType }) {
  const { login, isLoggedIn, status } = useLogin();
  const {
    profile: { UID },
  } = useAccount();
  const [isLiked, setIsLiked] = useState(undefined);
  const { loading, error, data } = useQuery(GetUserLike, {
    variables: {
      interactionId: id,
      userId: UID,
      name: likeType,
    },
    skip: !UID,
    fetchPolicy: 'network-only',
  });
  const [likeContent] = useMutation(Like);

  useEffect(() => {
    if (status !== 'idle' && status !== 'success') {
      return;
    }

    if (isLoggedIn === false) {
      setIsLiked(false);
      return;
    }

    if (data?.me) {
      setIsLiked(data.me.isLiked);
    }
  }, [data, status, isLoggedIn]);

  /**
   * This function returns:
   * - `null` when not logged in
   * - `true` when liked
   * - `false` when unliked
   */
  function toggleLike() {
    if (!isLoggedIn) {
      login();

      return null;
    }

    if (isLiked === undefined) {
      return null;
    }

    const newValue = !isLiked;

    setIsLiked(newValue);

    likeContent({
      variables: { interactionId: id, userId: UID, name: likeType },
    });

    return newValue;
  }

  return {
    isLiked,
    isReady: isLiked !== undefined && !loading && !error,
    toggleLike,
  };
}
